import * as React from "react";
import { useCallback } from "react";
import DropdownSelect from "./TurnrDropdownSelect";
import { LANGUAGE_OPTIONS } from "~/constants";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";
import { getEnabledLanguages } from "~/cores/brandDataCore";
import styles from "./LanguageSelect.module.scss";

export function LanguageDropdownRender({ languageCode }) {
    const languageData = LANGUAGE_OPTIONS.find((lo) => lo.value === languageCode);

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <div>{languageData.label}</div>
            <div
                style={{
                    height: "min-content",
                    display: "flex",
                    boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
                    marginLeft: "20px",
                }}
            >
                <CustomImageNew src={languageData?.icon} fixedWidth={30} fixedHeight={22} />
            </div>
        </div>
    );
}

export function LanguageSelectedRender({ languageCode }) {
    const languageData = LANGUAGE_OPTIONS.find((lo) => lo.value === languageCode);

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "nowrap",
                justifyContent: "space-between",
                width: "100%",
                whiteSpace: "nowrap",
            }}
        >
            {languageData.label}
        </div>
    );
}

export default function LanguageSelect(props) {
    const { value, appProps, onChange, languageCodes } = props;

    const enabledLanguages = languageCodes || getEnabledLanguages(appProps);

    const renderOption = useCallback((languageCode) => {
        return <LanguageDropdownRender languageCode={languageCode} />;
    }, []);

    const renderSelected = useCallback(
        (languageCode) => {
            return <LanguageSelectedRender languageCode={languageCode} appProps={appProps} />;
        },
        [appProps],
    );

    const getSearchKey = useCallback((languageCode) => {
        return LANGUAGE_OPTIONS.find((lo) => lo.value === languageCode).label;
    }, []);

    return (
        <DropdownSelect
            // hideArrow={true}

            style={{
                minWidth: 0,
                minHeight: "18px",
                fontSize: "12px",
                lineHeight: "1.2",
            }}
            color={"rgb(128, 128, 128)"}
            hideArrow={false}
            noLeftBox={true}
            arrowSize={"11px"}
            className={styles["select"]}
            selectedClassName={styles["select-selected"]}
            fieldsetStyle={{ borderWidth: 0, outline: "0 !important" }}
            value={value}
            onChange={onChange}
            tooltipPlacement={"top-left"}
            getSearchKey={getSearchKey}
            options={enabledLanguages}
            renderSelected={renderSelected}
            renderOption={renderOption}
            size={"medium"}
            {...props}
        />
    );
}
